import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="px-4 md:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-7xl mx-auto">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">
                6080<span className="text-primary-500">电影网</span>
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              高清电影免费在线观看，海量免费高清影视资源，不缓冲秒开，极速观影体验。涵盖最新电影、经典大片，免费看不停。
            </p>
          </div>

          <div>
            <h4 className="font-bold text-foreground-50 text-sm mb-4">电影分类</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <Link
                  key={cat.slug}
                  to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                  className="text-foreground-400 hover:text-primary-500 text-sm transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-foreground-50 text-sm mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-foreground-400 hover:text-primary-500 text-sm transition-colors">
                首页推荐
              </Link>
              <Link to="/category/action" className="text-foreground-400 hover:text-primary-500 text-sm transition-colors">
                动作电影
              </Link>
              <Link to="/category/scifi" className="text-foreground-400 hover:text-primary-500 text-sm transition-colors">
                科幻大片
              </Link>
              <Link to="/about" className="text-foreground-400 hover:text-primary-500 text-sm transition-colors">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-foreground-50 text-sm mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-foreground-400 hover:text-primary-500 text-sm transition-colors">
                品牌介绍
              </Link>
              <Link to="/about" className="text-foreground-400 hover:text-primary-500 text-sm transition-colors">
                联系方式
              </Link>
              <Link to="/about" className="text-foreground-400 hover:text-primary-500 text-sm transition-colors">
                用户口碑
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 max-w-7xl mx-auto">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 6080电影网 - 高清电影免费在线观看。本站所有资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-foreground-50 transition-colors" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-foreground-50 transition-colors" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-foreground-50 transition-colors" rel="nofollow">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}